import { ListManagerFrontendError } from './ListManagerFrontendError';

// Superclass for frontend configuration errors.
export class ConfigError extends ListManagerFrontendError {
  static errorName = 'ConfigError';
}
